import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { MyCheckbox, TextInput } from "../Shared/Forms";
import { Spinner } from "../Shared";

import CoreDomains from "../ISW-Core/Domains";

import { domainActions } from "./actions/domains.actions";
import { routeConstants } from "../../_constants";

export class DomainForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getDomain();
  }

  componentWillUnmount() {
    this.props.resetDomain();
  }

  getDomain = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getDomain(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.domainForm.reset();
      if (this.coreDomains) {
        this.coreDomains.domainCode.changeValue(null);
      }
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequest = data => {
    let request = { ...data };

    if (request.domain) {
      request = {
        code: request.domain.code,
        description: request.domain.name,
        ...request
      };
      delete request.domain;
    }

    return request;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      requestBody = {
        id: match.params.id,
        ...requestBody
      };
    }
    this.props.addDomain(requestBody);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const domain = viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.DOMAINS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Domain
                <small>{domain && hasParams ? `: ${domain.code}` : null}</small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="domainForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                {hasParams ? (
                  <div>
                    <TextInput
                      name="code"
                      value={domain && hasParams ? domain.code : null}
                      required
                      disabled={submitting || hasParams}
                      title="Domain code"
                    />

                    <TextInput
                      name="description"
                      value={domain && hasParams ? domain.description : null}
                      required
                      disabled={submitting}
                      title="Domain description"
                    />
                  </div>
                ) : (
                  <CoreDomains
                    value={domain && hasParams ? domain.code : null}
                    disabled={submitting || hasParams}
                    innerRef={c => {
                      this.coreDomains = c;
                    }}
                    name="domain"
                  />
                )}

                <MyCheckbox
                  name="enabled"
                  title="Enable domain"
                  validating={submitting}
                  value={domain && hasParams ? domain.enabled : false}
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { submitting, submitted, request, response, error } = state.addDomain;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewDomain;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addDomain: bindActionCreators(domainActions.addDomain, dispatch),
    resetDomain: bindActionCreators(domainActions.resetDomain, dispatch),
    getDomain: bindActionCreators(domainActions.getDomain, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DomainForm);
